// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";

// const SearchModal = ({ isOpen, onClose }) => {
//   const [query, setQuery] = useState("");
//   const [results, setResults] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const APP_URL = `https://tyka.premierhostings.com/backend/storage`;
//   const navigate = useNavigate();
//   const modalRef = useRef(null);

//   // Fetch search results
//   useEffect(() => {
//     if (!query.trim()) {
//       setResults([]);
//       return;
//     }

//     const delayDebounce = setTimeout(async () => {
//       try {
//         setLoading(true);
//         const res = await fetch(
//           `https://tyka.premierhostings.com/backend/api/search?q=${query}`
//         );
//         const data = await res.json();
//         setResults(data?.data || []);
//       } catch (err) {
//         console.error("Search error:", err);
//       } finally {
//         setLoading(false);
//       }
//     }, 500);

//     return () => clearTimeout(delayDebounce);
//   }, [query]);

//   // Close modal on ESC
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [onClose]);

//   // Close modal on outside click
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (modalRef.current && !modalRef.current.contains(e.target)) {
//         onClose();
//       }
//     };
//     if (isOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isOpen, onClose]);

//   const handleSelect = (id) => {
//     onClose();
//     navigate(`/productpage/${id}`);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50">
//       <div
//         ref={modalRef}
//         className=" w-full max-w-3xl mt-20 p-4 rounded-lg shadow-lg"
//       >
//         {/* 🔍 Search Input */}
//         <input
//           type="text"
//           value={query}
//           onChange={(e) => setQuery(e.target.value)}
//           placeholder="Search products..."
//           className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//         />

//         {/* Results */}
//         <div className="mt-4 max-h-80 overflow-y-auto">
//           {loading && <p className="text-gray-500">Searching...</p>}
//           {!loading && results.length === 0 && query && (
//             <p className="text-gray-500">No results found</p>
//           )}
//           {!loading &&
//             results.map((item) => (
//               <div
//                 key={item.id}
//                 onClick={() => handleSelect(item.slug)}
//                 className="p-2 border-b bg-white hover:bg-gray-100 cursor-pointer flex items-center"
//               >
//                 <img
//                   src={
//                     item.default_image
//                       ? `${APP_URL}/${item.default_image}`
//                       : "/placeholder.png"
//                   }
//                   alt={item.name}
//                   className="w-12 h-12 object-cover mr-3 rounded"
//                 />
//                 <div>
//                   <p className="font-semibold">{item.name}</p>
//                   <p className="text-sm text-gray-500">{item.category}</p>
//                 </div>
//               </div>
//             ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SearchModal;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const SearchModal = ({ isOpen, onClose }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const APP_URL = `https://tyka.premierhostings.com/backend/storage`;
  const navigate = useNavigate();

  // Fetch search results
  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      return;
    }

    const delayDebounce = setTimeout(async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `https://tyka.premierhostings.com/backend/api/search?q=${query}`
        );
        const data = await res.json();
        setResults(data?.data || []);
      } catch (err) {
        console.error("Search error:", err);
      } finally {
        setLoading(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [query]);

  // Close modal on ESC
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  const handleSelect = (id) => {
    onClose();
    navigate(`/${id}`);
    setQuery(""); //remove search data history
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50"
      onClick={onClose} // backdrop पर click → close
    >
      {/* Modal Content */}
      <div
        className=" w-full max-w-3xl mt-20 p-4 rounded-lg shadow-lg"
        onClick={(e) => e.stopPropagation()} // अंदर click → close ना हो
      >
        {/* 🔍 Search Input */}
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search products..."
          className="w-full  p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
        />

        {/* Results */}
        <div className="mt-4 max-h-80 overflow-y-auto bg-white">
          {loading && <p className="text-gray-500">Searching...</p>}
          {!loading && results.length === 0 && query && (
            <p className="text-gray-500">No results found</p>
          )}
          {!loading &&
            results.map((item) => (
              <div
                key={item.id}
                onClick={() => handleSelect(item.slug)}
                className="p-2 border-b hover:bg-gray-100 cursor-pointer flex items-center"
              >
                <img
                  src={
                    item.default_image
                      ? `${item.default_image}`
                      : "/placeholder.png"
                  }
                  alt={item.name}
                  className="w-12 h-12 object-cover mr-3 rounded"
                />
                <div>
                  <p className="font-semibold">{item.name}</p>
                  <p className="text-sm text-gray-500">{item.category}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SearchModal;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { X } from "lucide-react"; // cross icon

// const SearchModal = ({ isOpen, onClose }) => {
//   const [query, setQuery] = useState("");
//   const [results, setResults] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [history, setHistory] = useState([]); // ✅ search history
//   const APP_URL = `https://tyka.premierhostings.com/backend/storage`;
//   const navigate = useNavigate();

//   // Load history from localStorage on mount
//   useEffect(() => {
//     const savedHistory =
//       JSON.parse(localStorage.getItem("searchHistory")) || [];
//     setHistory(savedHistory);
//   }, []);

//   // Save search query into history
//   const addToHistory = (term) => {
//     if (!term.trim()) return;
//     let updated = [term, ...history.filter((h) => h !== term)].slice(0, 5); // only last 5
//     setHistory(updated);
//     localStorage.setItem("searchHistory", JSON.stringify(updated));
//   };

//   // Remove one item from history
//   const removeFromHistory = (term) => {
//     let updated = history.filter((h) => h !== term);
//     setHistory(updated);
//     localStorage.setItem("searchHistory", JSON.stringify(updated));
//   };

//   // Fetch search results
//   useEffect(() => {
//     if (!query.trim()) {
//       setResults([]);
//       return;
//     }

//     const delayDebounce = setTimeout(async () => {
//       try {
//         setLoading(true);
//         const res = await fetch(
//           `https://tyka.premierhostings.com/backend/api/search?q=${query}`
//         );
//         const data = await res.json();
//         setResults(data?.data || []);
//       } catch (err) {
//         console.error("Search error:", err);
//       } finally {
//         setLoading(false);
//       }
//     }, 500);

//     return () => clearTimeout(delayDebounce);
//   }, [query]);

//   // Close modal on ESC
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [onClose]);

//   const handleSelect = (slug, name) => {
//     addToHistory(name); // ✅ save into history
//     onClose();
//     navigate(`/${slug}`);
//   };

//   if (!isOpen) return null;

//   return (
//     <div
//       className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50"
//       onClick={onClose}
//     >
//       {/* Modal Content */}
//       <div
//         className=" w-full max-w-3xl mt-20 p-4 rounded-lg shadow-lg bg-white"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* 🔍 Search Input */}
//         <input
//           type="text"
//           value={query}
//           onChange={(e) => setQuery(e.target.value)}
//           placeholder="Search products..."
//           className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//         />

//         {/* Results OR History */}
//         <div className="mt-4 max-h-80 overflow-y-auto">
//           {loading && <p className="text-gray-500">Searching...</p>}

//           {/* Show Results */}
//           {!loading && results.length > 0 && (
//             <>
//               {results.map((item) => (
//                 <div
//                   key={item.id}
//                   onClick={() => handleSelect(item.slug, item.name)}
//                   className="p-2 border-b hover:bg-gray-100 cursor-pointer flex items-center"
//                 >
//                   <img
//                     src={item.default_image || "/placeholder.png"}
//                     alt={item.name}
//                     className="w-12 h-12 object-cover mr-3 rounded"
//                   />
//                   <div>
//                     <p className="font-semibold">{item.name}</p>
//                     <p className="text-sm text-gray-500">{item.category}</p>
//                   </div>
//                 </div>
//               ))}
//             </>
//           )}

//           {/* Show History when no query */}
//           {!loading && query === "" && history.length > 0 && (
//             <div>
//               <p className="text-sm text-gray-500 mb-2">Recent Searches</p>
//               {history.map((term, idx) => (
//                 <div
//                   key={idx}
//                   className="flex justify-between items-center p-2 border-b hover:bg-gray-100"
//                 >
//                   <span
//                     className="cursor-pointer"
//                     onClick={() => setQuery(term)}
//                   >
//                     {term}
//                   </span>
//                   <X
//                     size={16}
//                     className="cursor-pointer text-gray-500 hover:text-red-500"
//                     onClick={() => removeFromHistory(term)}
//                   />
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* No results */}
//           {!loading && results.length === 0 && query && (
//             <p className="text-gray-500">No results found</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SearchModal;
